import React from 'react';
import TableHeader from './TableHeader';
import TableBody from "./TableBody";

function PaginatedTable({headers, data}) {
    return (
        <table className="sl-table sl-width-100 sl-pb-32 sl-border-collapse sl-border-spacing-0">
            <TableHeader headers={headers}/>
            <TableBody data={data}/>
        </table>
    );
}

export default PaginatedTable;
